import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScVipTransferForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-width: 0;

  & .title {
    text-transform: uppercase;
    ${typography.headline3mobile};
  }

  & .uploaders-wrapper {
    display: flex;
    gap: 16px;
    @media (min-width: 800px) and (max-width: 1000px) {
      flex-direction: column;
    }
    @media (${device.mobileXS}) {
      flex-direction: column;
    }
  }
`;

export const ScErrorText = styled.span`
  ${typography.body1regular};
  color: ${({ theme }) => theme.redColor};
`;
